export default {
    setClassLists(store, payload) {
        store.classLists = payload;
    },
};
